'<template>
   <div class="page_member_join_container" >
      <div class="max_width">
         <div class="container_nav">
            当前位置：<router-link to="/">首页 - </router-link><a>会员名录</a>
         </div>
         <div class="table_content">
            <el-table :data="gridData" v-loading="loading" stripe>
               <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
               <el-table-column property="name" label="企业名称"></el-table-column>
               <el-table-column   label="企业类型" width="200">
                  <template slot-scope="scope">
                     {{scope.row.companyType == 1?'会员单位':'理事单位'}}
                  </template>
               </el-table-column>
               <el-table-column property="industry" label="行业" width="200"></el-table-column>
             <!--  <el-table-column label="操作" width="100">无</el-table-column>-->
            </el-table>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'member_list_page',
      components: { },
      data() {
         return {
            loading: false,

            gridData: [],
         };
      },
      mounted() {
         this.init();
      },
      methods: {
         init(){
            var _this = this;
            _this.$api.companyList({
            }).then(res => {
               if (res.code == 200) {
                  _this.gridData = res.data;
                  _this.loading = false;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.$message.error(error.msg);
            });

         },
      }
   }
</script>
<style lang="less">

</style>
